import {Component, HostBinding, Input} from '@angular/core';
import {NgIf} from "@angular/common";

@Component({
  selector: 'app-x-divider',
  standalone: true,
  imports: [NgIf],
  templateUrl: './x-divider.component.html',
  styleUrl: './x-divider.component.less',
})
export class XDividerComponent {
  @Input() type: 'small' | 'medium' | 'no-padding' = 'small';
  @Input() orientation: 'horizontal' | 'vertical' = 'horizontal';
  @Input() showLine: boolean = true;
  @Input() customColor: string = '';

  /** The classes to attach to the element. */
  @HostBinding('class')
  get elementClasses() {
    return {
      [this.type]: true,
      [this.orientation]: true,
    };
  }
}
